
export const backendserverurl = 'https://dsacco-9555546bk-01.pitech.co.ug'
// Add any other JavaScript code here
                    
//http://127.0.0.1:8000/

//http://104.131.54.129:10225

//